import { PropsWithChildren } from 'react'
import { useLocation } from 'react-router-dom'
import Text from '@/components/content/Text'
import type { MenuParentModel } from '@/services/auth/menu.types'
import { useGetMenuList } from '@/services/auth/useAuthQueries'

/** `/{parent}/{child}` 가 권한 메뉴에 있는지. 조각 2개 미만(`/`, `/gi`)은 메뉴 화면이 아니라 통과, 상세 경로는 앞 두 조각만 본다. */
export function isMenuAllowed(pathname: string, menuList: MenuParentModel[]): boolean {
  // 라우터는 대소문자를 가리지 않고, 메뉴 코드는 소문자다.
  const [parent, child] = pathname.toLowerCase().split('/').filter(Boolean)
  if (!child) return true
  return menuList.some((p) => p.menuCode === parent && p.menuItem.some((c) => c.menuCode === child))
}

/** 권한 메뉴 목록에 없는 화면은 본문을 그리지 않는다. 목록 refetch 는 `MainSideBar`(마운트)·`MainHeader`(화주 전환)가 맡는다. */
function MenuGuard({ children }: PropsWithChildren) {
  const { pathname } = useLocation()
  const { data, isFetching, isError } = useGetMenuList()

  // 같은 queryKey 를 refetch 하는 동안엔 이전 화주 메뉴가 data 에 남아 있어 판정을 미룬다.
  if (isFetching) return null
  // 메뉴 조회는 retry 0·에러 토스트 없음이라 실패를 여기서 알린다.
  if (isError) return <Text kind="Body_14_regular">메뉴 정보를 불러오지 못했습니다. 새로고침해 주세요</Text>
  if (data === undefined) return null
  if (!isMenuAllowed(pathname, data)) return <Text kind="Body_14_regular">접근 권한이 없는 메뉴입니다</Text>

  return <>{children}</>
}

export default MenuGuard
